<template>
  <div class="addnoticelist">
    <m-title :titlelist="navigationMsgGt"></m-title>
    <div class="componentSty_content">
      <div class="addnoticelist_content">
        <div class="formcont">
          <el-form
            :model="addinfo"
            :rules="rules"
            ref="forms"
            :show-message="false"
          >
            <div class="lineitem">
              <el-form-item label="分类" prop="noticeType">
                <el-select v-model="addinfo.noticeType" placeholder="请选择">
                  <el-option
                    v-for="item in selectastrict"
                    :key="item.id"
                    :label="item.val"
                    :value="item.val"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="lineitem" v-if="modules === 'add'">
              <el-form-item label="等级" prop="noticeLevel">
                <el-select v-model="addinfo.noticeLevel" placeholder="请选择">
                  <el-option
                    v-for="item in selectastrict1"
                    :key="item.id"
                    :label="item.val"
                    :value="item.val"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="lineitem" v-if="modules === 'edit'">
              <span>时间</span>
              <span style="margin-left: 20px">{{
                mydateFormat(addinfo.gmtCreate, "时分秒")
              }}</span>
            </div>
            <div class="lineitem">
              <el-form-item label="标题" prop="noticeTitle">
                <input
                  class="lineitemipt"
                  type="text"
                  v-model="addinfo.noticeTitle"
                  placeholder="请输入标题（20字以内）"
                />
              </el-form-item>
            </div>
            <div class="textarte">
              <quillEditor
                v-model="addinfo.noticeContext"
                :options="editorOption"
                style="width: 100%; height: 100%"
              ></quillEditor>
            </div>
          </el-form>
          <div class="bottombtns">
            <div class="btn">
              <button
                style="background: #f3f4f5; color: #17B6A1"
                @click="returnpage"
              >
                返回
              </button>
              <button style="margin-left: 30px" @click.stop="newsnotice">
                确定
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mTitle from "@/components/mTitle";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import { mapGetters } from "vuex";
export default {
  name:"addnoticelist",
  data() {
    let that = this;
    let ipt = null;
    return {
      modules: "",
      selectastrict: [],
      selectastrict1: [],
      addinfo: {
        noticeContext: "", //公告内容
        noticeTitle: "", //公告标题
        noticeType: "", //公告类型
        peopleCreate: "", //创建人
        noticeLevel: "", //等级
        peopleModified: "2",
      },
      editorOption: {
        modules: {
          toolbar: {
            container: [
              ["bold", "italic", "underline"], // toggled buttons
              [{ list: "ordered" }, { list: "bullet" }],
              [{ script: "sub" }, { script: "super" }], // superscript/subscript
              [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
              [{ header: [1, 2, 3, 4, 5, 6, false] }],
              [{ color: [] }, { background: [] }], // dropdown with defaults from theme
              [{ align: [] }, "image"],
            ],
            handlers: {
              image: function () {
                if (!ipt) {
                  ipt = document.createElement("input");
                  ipt.setAttribute("type", "file");
                  ipt.setAttribute(
                    "accept",
                    "image/png, image/gif, image/jpeg,image/jpg"
                  );
                  ipt.addEventListener("change", async (_) => {
                    let isok =
                      !/\/+(jpg|jpeg|png|gif)+$/gi.test(ipt.files[0].type) &&
                      that.$message.error("请上传正确格式的图片");
                    isok =
                      !(ipt.files[0].size / (1024 * 1024) < 5) &&
                      that.$message.error("上传的图片得小于5M");
                    if (isok) return "";
                    const formData = new FormData();
                    formData.append("multipartFile", ipt.files[0]);
                    file.append('flag', "357779a88b0b5ab0c9b2b061cac69672");
                    const { data } = await that.$http(
                      "api1",
                      "/exchange/aliyun/uploadFile",
                      "post",
                      formData
                    );
                    if (data.code != 0)
                      return that.$message.error("上传图片失败");
                    let length = this.quill.getSelection(true).index;
                    this.quill.insertEmbed(length, "image", data.msg);
                    this.quill.setSelection(length + 1);
                  });
                }
                ipt.click();
              },
            },
          },
        },
      },
      rules: {
        noticeType: [{ required: true, trigger: "change" }],
        noticeLevel: [{ required: true, trigger: "change" }],
        noticeTitle: [
          { required: true, trigger: "blur" },
          { min: 1, max: 20, trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(["usergt", "navigationMsgGt"]),
  },
  created() {
    this.modules = this.$route.params.name;
    this.$route.params.name === "add" && this.gnoticeinfo();
    this.$route.params.name === "edit" &&
      (this.addinfo = JSON.parse(
        window.sessionStorage.getItem("noticeeditinfo")
      ));
    this.gnoticeinfotype();
  },
  components: {
    mTitle,
    quillEditor,
  },
  methods: {
    returnpage() {
      this.$router.push("/notice/noticelist");
    },
    // 获取公告类型
    async gnoticeinfotype() {
      const { data } = await this.$http(
        "api1",
        "/sys/dic/list?dictionaryType=" + "公告类型",
        "get"
      );
      if (data.code != 0) return this.$message.error(data.msg);
      this.selectastrict = data.data;
    },
    // 获取公告等级
    async gnoticeinfo() {
      const { data } = await this.$http(
        "api1",
        "/sys/dic/list?dictionaryType=" + "公告等级",
        "get"
      );
      if (data.code != 0) return this.$message.error(data.msg);
      this.selectastrict1 = data.data;
    },
    newsnotice() {
      this.addinfo.noticeContext &&
        (this.addinfo.noticeContext = this.addinfo.noticeContext.replace(
          /\<img/gi,
          "<img style='width:100%';height:100%'"
        ));
      switch (this.modules) {
        case "add":
          this.addinfomsg();
          break;
        case "edit":
          this.editinfo();
          break;
      }
    },
    async addinfomsg() {
      let isok =
        !this.addinfo.noticeType && this.$message.error("请选择公告类别");
      isok =
        isok ||
        (!this.addinfo.noticeLevel && this.$message.error("请选择公告等级"));
      isok =
        isok ||
        (!this.addinfo.noticeTitle && this.$message.error("请填写标题"));
      if (isok) return "";
      this.addinfo.peopleCreate = this.usergt.username;
      this.addinfo.gmtCreate = new Date().getTime();
      const { data } = await this.$http(
        "api1",
        "/notice/message/save",
        "post",
        this.addinfo
      );
      if (data.code != 0) return this.$message.error(data.msg);
      this.$message.success("添加成功");
      this.returnpage();
    },
    async editinfo() {
      let isok =
        !this.addinfo.noticeType && this.$message.error("请选择公告类别");
      isok =
        isok ||
        (!this.addinfo.noticeTitle && this.$message.error("请填写标题"));
      if (isok) return "";
      this.addinfo.gmtModified = new Date().getTime();
      const { data } = await this.$http(
        "api1",
        "/notice/message/update",
        "post",
        this.addinfo
      );
      if (data.code != 0) return this.$message.error(data.msg);
      this.$message.success("修改成功");
      this.returnpage();
    },
  },
};
</script>
<style lang="scss" scoped>
.addnoticelist {
  position: relative;
  height: 100%;
  .componentSty_content {
    position: absolute;
    top: 50px;
    bottom: 0;
    width: 100%;
    background: #fff;
  }
  .addnoticelist_content {
    position: relative;
    box-sizing: border-box;
    height: 100%;
    background: #ffffff;
    border-radius: 2px;
    padding: 2%;
    .formcont {
      height: 95%;
      width: 100%;
      .lineitem {
        height: 10%;
        .lineitemipt {
          box-sizing: border-box;
          padding: 0;
          height: 30px;
          outline: none;
          border: none;
          width: 420px;
          background: #f3f4f5;
          padding-left: 10px;
          border-radius: 5px;
          font-size: 60%;
        }
      }
      .textarte {
        height: 60%;
        width: 100%;
        .textareaipt {
          float: left;
          width: 90%;
          height: 80%;
          background: #f3f4f5;
          border: none;
          resize: none;
          outline: none;
          border-radius: 5px;
          font-size: 60%;
        }
      }
    }
    .bottombtns {
      height: 5%;
      width: 100%;
      .btn {
        float: right;
        margin-right: 8%;
        button {
          width: 80px;
          height: 30px;
          background: #17B6A1;
          border-radius: 5px;
          border: none;
          color: #fff;
        }
      }
    }
  }
}
</style>